export default "__VITE_ASSET__Eg9QhXOS__"